import { type Action, createAsyncThunk, type ThunkDispatch } from '@reduxjs/toolkit';
import type { IState } from 'redux/state';
import { ticApi } from '../api-slice/tic.apiSlice';
import { getAssistantResponseQuery } from './tic.ai.agent.selector';

export const getAssistantResponse = createAsyncThunk<
  void,
  { message: string; session_id?: string },
  { state: IState; dispatch: ThunkDispatch<IState, any, Action> }
>('tic/agent/getAssistantResponse', async (args, thunkAPI) => {
  const state = thunkAPI.getState();
  const { message, session_id } = args;
  const { timelyAccountId } = getAssistantResponseQuery(state);
  const payload = {
    message,
    timelyAccountId,
    session_id,
  };
  thunkAPI.dispatch(ticApi.endpoints.getAssistantResponse.initiate(payload, {}));
});
